import settingsIcon from "../../assets/all-icons/settings-gear-dark-purple.png";
import slidersIcon from "../../assets/all-icons/faders-sliders-dark-purple.png";
import documentIcon from "../../assets/all-icons/document-clipboard-dark-purple.png";
import monitorIcon from "../../assets/all-icons/monitor-screen-dark-purple.png";
import { useInView } from "../../hooks/useInView";

const FEATURES = [
  {
    icon: settingsIcon,
    title: "Simple Process",
    description: "Fully digital workflow, from verification to payout.",
  },
  {
    icon: slidersIcon,
    title: "Flexible Options",
    description: "Tailor your repayment timeline to your paycheck frequency.",
  },
  {
    icon: documentIcon,
    title: "Transparent Terms",
    description: "Zero hidden charges or unexpected early foreclosure fees.",
  },
  {
    icon: monitorIcon,
    title: "Digital Experience",
    description:
      "Track everything online anytime with a smooth, intuitive dashboard.",
  },
];

export function WhyChooseUs() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-[#f7f4fb] px-4 py-16 sm:py-20">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-10">
        {/* Header row */}
        <div
          ref={ref}
          className={`flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center ${inView ? "in-view" : ""}`}
        >
          <div className="flex max-w-[420px] flex-col items-start gap-4">
            <span className="reveal-scroll delay-1 rounded-full bg-[#ede9fe] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
              Why Choose GenzPaisa?
            </span>
            <h2 className="reveal-scroll delay-2 text-3xl font-extrabold leading-tight tracking-[-0.5px] text-[#1c1917] sm:text-4xl">
              More than just loans. A smarter way forward.
            </h2>
          </div>

          <p className="reveal-scroll delay-3 max-w-[420px] text-base leading-6 text-[#475569]">
            It&apos;s easier than ever before. A straightforward digital loan
            experience designed to make borrowing easier to understand and
            manage.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((feature, idx) => (
            <div
              key={feature.title}
              className="reveal-scroll flex flex-col rounded-[20px] bg-white p-6 shadow-[0px_1px_2px_rgba(0,0,0,0.04)]"
              style={{
                animationDelay: `${0.4 + idx * 0.1}s`,
              }}
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#ede9fe]">
                <img src={feature.icon} alt="" className="h-5 w-5" />
              </span>
              <h3 className="pt-3 text-base font-bold leading-5 text-[#1c1917]">
                {feature.title}
              </h3>
              <p className="pt-2 text-sm leading-5 text-[#64748b]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
